<app-datatable [dataSource]="userSource" [columns]="columns" [identifier]="'users'" [customActions]="customActions" [iconActions]="iconActions"
  (newEvent)="new()" (showEvent)="edit($event.valueOf())">
  <app-empty-table [icon]="'person'" [emptyText]="'user.empty_text' | translate" [buttonText]="'user.createNew' | translate"
    (btnClick)="new()">
  </app-empty-table>
</app-datatable>

<app-error [error]="error"></app-error>

<app-model-modal #EditModal (saveEvent)="onSave()">
  <app-user-form #form (closeEvent)="onModalClose()" (loadingEvent)="onLoading($event.valueOf())"></app-user-form>
</app-model-modal>
